import Api from "./Api";

const abortKey = "FiBuBuchungApi";
const endpoint = "/fibu/buchung";
export default {
    abort() {
        Api.abort(abortKey);
    },
    get(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint, usedParams, true, false, abortKey);
    },
    getSingle(id, params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint + "/" + id, usedParams);
    },
    getSums(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(
            endpoint + "/sums",
            usedParams,
            true,
            false,
            abortKey
        );
    },
    getGroupedSums(group_id, params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(
            endpoint + "/sums/group/" + group_id,
            usedParams,
            true,
            false,
            abortKey
        );
    },
    put(id, data) {
        return Api.putData(endpoint + "/" + id, data);
    },
    putGruppierungskonten(id, data) {
        return Api.putData(endpoint + '/' + id + '/gruppierungskonten', data)
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    delete(id) {
        return Api.deleteData(endpoint + "/" + id);
    },
    getYears() {
        return Api.fetchData(endpoint + "/years");
    },
    printRequestedBookings(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(
            endpoint + "/print",
            usedParams,
            true,
            false,
            abortKey
        );
    },
    getLastBookings() {
        var usedParams = {}

        return Api.fetchData(
            endpoint + '/last-bookings', usedParams, true, false, abortKey
        );
    }
};
